import { mdiAccountMultiple, mdiAccountVoice, mdiHandCoin, mdiQualityHigh, mdiShieldLock, mdiStairsUp } from "@mdi/js";
import Icon from "@mdi/react";

export default function Diferenciais() {
    return (
        <>
            <section id="diferenciais" className="about section light-background">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">
                        <div>
                            <span>Nossos</span> <span className="description-title">Diferenciais</span>
                        </div>
                    </div>

                    <div className="row">
                        {/* Diferencial 1 */}
                        <div className="col-md-6 text-center my-4" data-aos="fade-right">
                            <div className="service-item">
                                <div className="service-header">
                                    <div className="icon-wrapper mb-2">
                                        <Icon path={mdiAccountVoice} size={4} />
                                    </div>
                                </div>
                                <h3>Clareza desde o início</h3>
                                <p>Escopo, prazos e investimentos sem surpresas.</p>
                            </div>
                        </div>

                        {/* Diferencial 2 */}
                        <div className="col-md-6 text-center my-4" data-aos="fade-left">
                            <div className="service-item">
                                <div className="service-header">
                                    <div className="icon-wrapper mb-2">
                                        <Icon path={mdiAccountMultiple} size={4} />
                                    </div>
                                </div>
                                <h3>Comunicação simples</h3>
                                <p>Você entende cada etapa, sem “tecniquês”.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        {/* Diferencial 3 */}
                        <div className="col-md-6 text-center my-4" data-aos="fade-right">
                            <div className="service-item">
                                <div className="service-header">
                                    <div className="icon-wrapper mb-2">
                                        <Icon path={mdiStairsUp} size={4} />
                                    </div>
                                </div>
                                <h3>Entrega com foco em valor</h3>
                                <p>Priorizamos o que traz resultado primeiro.</p>
                            </div>
                        </div>

                        {/* Diferencial 4 */}
                        <div className="col-md-6 text-center my-4" data-aos="fade-left">
                            <div className="service-item">
                                <div className="service-header">
                                    <div className="icon-wrapper mb-2">
                                        <Icon path={mdiQualityHigh} size={4} />
                                    </div>
                                </div>
                                <h3>Qualidade consistente</h3>
                                <p>Testes, revisão e atenção aos detalhes.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        {/* Diferencial 5 */}
                        <div className="col-md-6 text-center my-4" data-aos="fade-right">
                            <div className="service-item">
                                <div className="service-header">
                                    <div className="icon-wrapper mb-2">
                                        <Icon path={mdiShieldLock} size={4} />
                                    </div>
                                </div>
                                <h3>Segurança e privacidade (LGPD)</h3>
                                <p>Seus dados tratados com responsabilidade.</p>
                            </div>
                        </div>

                        {/* Diferencial 6 */}
                        <div className="col-md-6 text-center my-4" data-aos="fade-left">
                            <div className="service-item">
                                <div className="service-header">
                                    <div className="icon-wrapper mb-2">
                                        <Icon path={mdiHandCoin} size={4} />
                                    </div>
                                </div>
                                <h3>Pós-entrega de verdade</h3>
                                <p>Acompanhamento e evolução contínua.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
